import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';
import {
  DoohTargetingBaseSchemaDefaultValue,
  TargetingBaseSchemaDefaultValue
} from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseSchema';

export const getTargetingByMediaChannel = (mediaChannel: CampaignFamilyEnum) => {
  if (mediaChannel === CampaignFamilyEnum.dooh) {
    return DoohTargetingBaseSchemaDefaultValue;
  }
  if (mediaChannel === CampaignFamilyEnum.ctv) {
    return {
      ...TargetingBaseSchemaDefaultValue,
      devicePlatform: TargetingBaseSchemaDefaultValue.devicePlatform.map(devicePlatform => ({
        ...devicePlatform,
        enable: devicePlatform.name === CampaignFamilyEnum.ctv
      }))
    };
  }
  return TargetingBaseSchemaDefaultValue;
};
